import {
  Row,
  Col,
  Select as AntSelect,
  Form,
  Divider,
  Upload,
  Checkbox as AntCheckbox,
  InputNumber,
  Typography,
} from 'antd';
import Radio from 'components/radio';
import { PlusOutlined } from '@ant-design/icons';
import { ReactComponent as PhoneIcon } from 'icons/Phone_gold.svg';
import { ReactComponent as EnvelopeIcon } from 'icons/Envelope_gold.svg';
import { ReactComponent as WhatsuppIcon } from 'icons/whatsapp_gold.svg';
import { ReactComponent as CloudGold } from 'icons/cloud_gold.svg';

import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
  InputLabel,
  InputStyled,
  InputWrapper,
  Title,
  SelectStyled,
  StyledDatePicker,
  StyledButton,
  StylesTextArea,
  DraggerWrapper,
} from './styled';
import MainCheckbox from './checkbox';
import PaymentsAccept from './payments-accept';
import PurchaseShippingRates from './purhcase-shipping-rate';
import { getShoppingCenters } from '../../hooks/useUser';
import React, { Fragment, useEffect, useState } from 'react';
import FormHelper from '../../helpers/FormHelper';
import FileList from '../fileList/index.';
import Resi from './resi';
import moment from 'moment';
import UIHelper from '../../helpers/UIHelper';
import { EMPLOYEE_CONTACT_TYPES } from '../../constants/companies';

const { Dragger } = Upload;

export const Input = ({ label, labelAs = 'span', ...rest }) => {
  return (
    <InputWrapper>
      <InputLabel as={labelAs}>{label}</InputLabel>
      <InputStyled {...rest} />
    </InputWrapper>
  );
};

export const Select = ({ label, ...rest }) => {
  return (
    <InputWrapper>
      <InputLabel>{label}</InputLabel>
      <SelectStyled {...UIHelper.getSelectContainerProp()} {...rest} />
    </InputWrapper>
  );
};

const DatePicker = ({ label, ...rest }) => {
  return (
    <InputWrapper>
      <InputLabel>{label}</InputLabel>
      <StyledDatePicker {...rest} />
    </InputWrapper>
  );
};

export const Checkbox = ({ mainLabel, ...rest }) => {
  return (
    <InputWrapper>
      {mainLabel && <InputLabel>{mainLabel}</InputLabel>}
      <MainCheckbox {...rest} />
    </InputWrapper>
  );
};

const TextArea = ({ label, ...rest }) => {
  return (
    <InputWrapper>
      <InputLabel>{label}</InputLabel>
      <StylesTextArea rows={10} {...rest} />
    </InputWrapper>
  );
};

const GeneralInfo = ({
  chains,
  onChange,
  companyCategories,
  companyChildCategories,
  prestigeLevels,
  isNew,
  item,
  retailOrRoot,
  isEdit,
  siteCategories,
}) => {
  const { t } = useTranslation();
  const shoppingCenters = useRecoilValue(getShoppingCenters);

  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Row gutter={[12, 0]}>
          <Col span={12}>
            <Form.Item name='title'>
              <Input
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('title', isEdit)
                }
                label={t('Nome Insegna')}
                size='large'
                placeholder={t('Nome Insegna')}
                onChange={onChange}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='shopping_center_id'>
              <Select
                disabled={!retailOrRoot}
                label={t('Outlet Village')}
                size='large'
                placeholder={t('Outlet Village')}
                optionFilterProp='children'
              >
                <AntSelect.Option value={''}>
                  {t('Outlet Village')}
                </AntSelect.Option>
                {shoppingCenters?.map((item) => (
                  <AntSelect.Option key={item.id} value={item.id}>
                    {item.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='nego_id'>
              <Input
                disabled={!retailOrRoot}
                label={t('Nego ID')}
                size='large'
                placeholder={t('Nego ID')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='vat'>
              <Input
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('vat', isEdit)
                }
                label={t('IVA (solo numero)')}
                size='large'
                placeholder={t('IVA (solo numero)')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='chain_id'>
              <Select
                disabled={!retailOrRoot}
                label={t('Catena')}
                size='large'
                optionFilterProp='children'
              >
                <AntSelect.Option value={''}>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {chains?.map((item) => (
                  <AntSelect.Option key={item.value} value={item.value}>
                    {item.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_category_id'>
              <Select
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled(
                    'company_category_id',
                    isEdit,
                  )
                }
                label={t('Categoria insegna')}
                size='large'
                placeholder='Search to Select'
                optionFilterProp='children'
              >
                <AntSelect.Option value={''}>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {companyCategories?.map((i) => (
                  <AntSelect.Option key={i.value} value={i.value}>
                    {i.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='opening_date'>
              <DatePicker
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('opening_date', isEdit)
                }
                label='Data di apertura'
                size='large'
                format={'DD MMMM YYYY'}
                placeholder='Data di apertura'
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='closing_date'>
              <DatePicker
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('closing_date', isEdit)
                }
                label='Data di chiusura'
                size='large'
                format={'DD MMMM YYYY'}
                placeholder='Data di chiusura'
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='contract_start_date'>
              <DatePicker
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled(
                    'contract_start_date',
                    isEdit,
                  )
                }
                label='Data inizio contratto'
                size='large'
                format={'DD MMMM YYYY'}
                placeholder='Data inizio contratto'
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='contract_end_date'>
              <DatePicker
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('contract_end_date', isEdit)
                }
                label='Data di fine del contratto'
                size='large'
                format={'DD MMMM YYYY'}
                placeholder='Data di fine del contratto'
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='place_area'>
              <Input
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('place_area', isEdit)
                }
                label='Mq Unità'
                size='large'
                placeholder='Mq Unità'
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='location_code'>
              <Input
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('location_code', isEdit)
                }
                label={t('Codice Unità')}
                size='large'
                placeholder='Codice Unità'
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      {!isNew && (
        <>
          {/*// <Col span={24}>*/}
          {/*//   <Row gutter={[12, 12]}>*/}
          {/*//     <Col span={12}>*/}
          {/*//       <Form.Item name='commodity_category_id'>*/}
          {/*//         <Input*/}
          {/*//           label='ID categoria merceologica'*/}
          {/*//           size='large'*/}
          {/*//           placeholder='ID categoria merceologica'*/}
          {/*//         />*/}
          {/*//       </Form.Item>*/}
          {/*//     </Col>*/}
          {/*//     <Col span={12}>*/}
          {/*//       <Form.Item name='commodity_subcategory_code'>*/}
          {/*//         <Input*/}
          {/*//           label='Codice categoria merceologica'*/}
          {/*//           size='large'*/}
          {/*//           placeholder='Codice categoria merceologica'*/}
          {/*//         />*/}
          {/*//       </Form.Item>*/}
          {/*//     </Col>*/}
          {/*//   </Row>*/}
          {/*// </Col>*/}
        </>
      )}
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item hidden={true} name='commodity_category'>
              <Input
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled(
                    'commodity_category',
                    isEdit,
                  )
                }
                label='Categoria merceologica'
                size='large'
                placeholder='Categoria merceologica'
              />
            </Form.Item>
          </Col>
          {/*{!isNew && (*/}
          {/*  <Col span={12}>*/}
          {/*    <Form.Item name='commodity_subcategory_id'>*/}
          {/*      <Input*/}
          {/*        label='ID sottocategoria merce'*/}
          {/*        size='large'*/}
          {/*        placeholder='ID sottocategoria merce'*/}
          {/*      />*/}
          {/*    </Form.Item>*/}
          {/*  </Col>*/}
          {/*)}*/}
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_child_category_id'>
              <Select
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled(
                    'company_child_category_id',
                    isEdit,
                  )
                }
                label='Sottocategoria merceologica'
                size='large'
                placeholder='Sottocategoria merceologica'
                optionFilterProp='children'
              >
                <AntSelect.Option value={''}>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {companyChildCategories?.map((i) => (
                  <AntSelect.Option key={i.value} value={i.value}>
                    {i.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='prestige_level_id'>
              <Select
                disabled={
                  !retailOrRoot ||
                  FormHelper.isCompanyFieldDisabled('prestige_level_id', isEdit)
                }
                label='Segmento'
                size='large'
                placeholder='Search to Select'
                optionFilterProp='children'
              >
                <AntSelect.Option value={''}>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {prestigeLevels?.map((i) => (
                  <AntSelect.Option key={i.value} value={i.value}>
                    {i.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Form.Item
          disabled={
            !retailOrRoot || FormHelper.isCompanyFieldDisabled('food', isEdit)
          }
          name='food'
          valuePropName='checked'
          style={{ position: 'relative' }}
        >
          <Checkbox
            disabled={
              !retailOrRoot || FormHelper.isCompanyFieldDisabled('food', isEdit)
            }
            texts={{ checked: t('Yes'), unchecked: t('No') }}
            mainLabel='Food'
            label='Yes'
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Typography.Text
          style={{
            fontWeight: 400,
          }}
          level={5}
        >
          {t('Categoria sito web')}
        </Typography.Text>
        {siteCategories.map((category) => (
          <Input key={category.id} disabled value={category.title} />
        ))}
      </Col>
    </Row>
  );
};

const AdministratorContacts = ({ isNew }) => {
  return (
    <Row gutter={[24, 0]}>
      {EMPLOYEE_CONTACT_TYPES.map((title, index) => (
        <Col span={24}>
          <Row gutter={[24, 0]}>
            <Col span={4}>{title.title}</Col>
            <Col span={5}>
              {' '}
              <Form.Item
                name={`company_employee_contacts_attributes.name.${index}`}
              >
                <Input label='Nome' size='large' placeholder='Nome' />
              </Form.Item>
              <Form.Item
                name={`company_employee_contacts_attributes.id.${index}`}
                hidden={true}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={`company_employee_contacts_attributes.contact_type.${index}`}
                hidden={true}
                initialValue={title.value}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={5}>
              {' '}
              <Form.Item
                name={`company_employee_contacts_attributes.surname.${index}`}
              >
                <Input label='Cognome' size='large' placeholder='Cognome' />
              </Form.Item>
            </Col>
            <Col span={5}>
              {' '}
              <Form.Item
                name={`company_employee_contacts_attributes.phone.${index}`}
              >
                <Input
                  prefix={<PhoneIcon />}
                  label='Telefono'
                  size='large'
                  placeholder='Telefono'
                />
              </Form.Item>
            </Col>
            <Col span={5}>
              {' '}
              <Form.Item
                name={`company_employee_contacts_attributes.email.${index}`}
              >
                <Input label='Email' size='large' placeholder='Email' />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  );
};

const GeneralContacts = ({ isNew }) => {
  return (
    <Row gutter={[24, 0]}>
      <Col span={8}>
        <Form.Item name='company_data_attributes.phone'>
          <Input
            prefix={<PhoneIcon />}
            label='Phone'
            size='large'
            placeholder='Phone'
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name='company_data_attributes.email'>
          <Input
            prefix={<EnvelopeIcon />}
            label='E-mail'
            size='large'
            placeholder='E-mail'
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name='company_data_attributes.whatsapp'>
          <Input
            prefix={<WhatsuppIcon />}
            label='Whatsapp'
            size='large'
            placeholder='Whatsapp'
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name='company_data_attributes.whatsapp2'>
          <Input
            prefix={<WhatsuppIcon />}
            label='Whatsapp 2'
            size='large'
            placeholder='Whatsapp 2'
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name='company_data_attributes.whatsapp3'>
          <Input
            prefix={<WhatsuppIcon />}
            label='Whatsapp 3'
            size='large'
            placeholder='Whatsapp 3'
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

const Address = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_denominazione'>
              <Input
                label={t('Denominazione')}
                size='large'
                placeholder={t('Immettere Denominazione')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_address'>
              <Input
                label={t('Indirizzo')}
                size='large'
                placeholder={t('Immettere indirizzo')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_city'>
              <Input
                label={t('Citta')}
                size='large'
                placeholder={t('Immettere Citta')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_postal_code'>
              <Input
                label={t('Cap')}
                size='large'
                placeholder={t('Immettere Cap')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_province'>
              <Input
                label={t('Provincia')}
                size='large'
                placeholder={t('Immettere Provincia')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_tax_code'>
              <Input
                label={t('P.IVA / Codice Fiscale')}
                size='large'
                placeholder={'0000 0000 000'}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_data_attributes.address_unique_code'>
              <Input
                label={t('Codice Univoco')}
                size='large'
                placeholder={'0 XXXXX 0'}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_data_attributes.pec_aziendale'>
              <Input
                label={t('Pec aziendale')}
                size='large'
                placeholder={t('Pec aziendale')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const Personal = () => {
  const { t } = useTranslation();

  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_data_attributes.number_full_time_employees'>
              <Input
                label={t('Nr addetti in store (Full time)')}
                size='large'
                placeholder={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_data_attributes.number_part_time_employees'>
              <Input
                label={t('Nr addetti in store (Part-time)')}
                size='large'
                placeholder={0}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      {/*<Col span={24}>*/}
      {/*  <Row gutter={[12, 12]}>*/}
      {/*    <Col span={12}>*/}
      {/*      <Form.Item name='company_data_attributes.tax_free'>*/}
      {/*        <Select*/}
      {/*          label={t('Operatore tax free')}*/}
      {/*          size='large'*/}
      {/*          placeholder={t('Selezioni opzione')}*/}
      {/*          optionFilterProp='children'*/}
      {/*          name='company'*/}
      {/*        >*/}
      {/*          <AntSelect.Option value=''>*/}
      {/*            {t('Selezioni opzione')}*/}
      {/*          </AntSelect.Option>*/}
      {/*          <AntSelect.Option value='global_blue'>*/}
      {/*            Global Blue*/}
      {/*          </AntSelect.Option>*/}
      {/*          <AntSelect.Option value='planet'>Planet</AntSelect.Option>*/}
      {/*          <AntSelect.Option value='tax_free'>Tax free</AntSelect.Option>*/}
      {/*        </Select>*/}
      {/*      </Form.Item>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*</Col>*/}
    </Row>
  );
};

const Competitors = ({ competitors }) => {
  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_competitors.0'>
              <Select
                label='Competitor 1'
                size='large'
                placeholder='Competitor 1'
                optionFilterProp='children'
                {...UIHelper.getSelectSearchProps()}
              >
                <AntSelect.Option value='nil'>Not Identified</AntSelect.Option>
                {competitors &&
                  competitors.map((comp) => (
                    <AntSelect.Option value={comp.id}>
                      {comp.title}
                    </AntSelect.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_competitors.1'>
              <Select
                label='Competitor 2'
                size='large'
                placeholder='Competitor 2'
                optionFilterProp='children'
                name='company'
                {...UIHelper.getSelectSearchProps()}
              >
                <AntSelect.Option value='nil'>Not Identified</AntSelect.Option>
                {competitors &&
                  competitors.map((comp) => (
                    <AntSelect.Option value={comp.id}>
                      {comp.title}
                    </AntSelect.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Col>
      {/* <Col span={24}>
        <Row>
          <Col span={18}>
            <StyledButton
              type='primary'
              block={true}
              icon={<PlusOutlined style={{ marginRight: 2 }} />}
            >
              Add Competitor
            </StyledButton>
          </Col>
        </Row>
      </Col> */}
    </Row>
  );
};

const Conditions = ({ retailOrRoot, item }) => {
  const { t } = useTranslation();
  const draggerProps = {
    name: 'file',
    multiple: true,
    style: {
      height: '200px',
    },
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info) {},
    onDrop(e) {},
  };
  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <Form.Item name={'company_click_collect_attributes.return_product'}>
          <TextArea
            disabled={!retailOrRoot}
            label='Resi'
            placeholder='Immettere resi'
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item name={'company_click_collect_attributes.change_product'}>
          <TextArea
            disabled={!retailOrRoot}
            label='Cambi'
            placeholder='Immettere cambi'
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item name={'company_click_collect_attributes.guarantee_product'}>
          <TextArea
            disabled={!retailOrRoot}
            label='Garanzia'
            placeholder='Immettere garanzia'
          />
        </Form.Item>
      </Col>
      <Col span={24}>
        <div>
          <Form.Item label={t('Shop Policy Smart Shopping')}>
            <Form.Item
              name='shop_policy_click_collect'
              valuePropName='fileList'
              getValueFromEvent={FormHelper.normFile}
              noStyle
              multiple={false}
            >
              <Dragger
                name='file'
                multiple={false}
                beforeUpload={FormHelper.beforeUpload}
              >
                <p className='ant-upload-drag-icon'>
                  <CloudGold />
                </p>
                <p className='ant-upload-text'>
                  {t('Drag & drop files, or browse in your files')}
                </p>
              </Dragger>
            </Form.Item>
          </Form.Item>
          <Row>
            <Col span={24}>
              <FileList
                hideDeleteBtn={true}
                data={
                  item?.company_click_collect?.shop_policy_click_collect?.url
                    ? [
                        {
                          file: {
                            url: item?.company_click_collect
                              ?.shop_policy_click_collect?.url,
                            file_name:
                              item?.company_click_collect
                                ?.shop_policy_click_collect?.filename,
                            id: item?.company_click_collect
                              ?.shop_policy_click_collect?.id,
                          },
                          image_id:
                            item?.company_click_collect
                              ?.shop_policy_click_collect?.id,
                          param: 'shop_policy_click_collect',
                        },
                      ]
                    : []
                }
              />
            </Col>
          </Row>
          {item?.company_click_collect?.shop_policy_click_collect?.url && (
            <Form.Item
              valuePropName={'checked'}
              name={
                'company_click_collect_attributes.remove_shop_policy_click_collect'
              }
              label={'Cancella'}
            >
              <AntCheckbox />
            </Form.Item>
          )}
        </div>
      </Col>
    </Row>
  );
};

const Bank = ({ retailOrRoot, filtersData }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={8}>
            <Form.Item name='company_click_collect_attributes.api_key'>
              <Input
                disabled={!retailOrRoot}
                label={t('Api key')}
                size='large'
                placeholder={0}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='company_click_collect_attributes.shop_login'>
              <Input
                disabled={!retailOrRoot}
                label={t('Shop login')}
                size='large'
                placeholder={0}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.dev_mode'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Dev mode')}
                label={t('Enabled')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.backend_access_click_collect'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Attiva accesso backend')}
                label={t('Enabled')}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.view_online_click_collect'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Attiva insegna online')}
                label={t('Disabled')}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.is_whatsapp'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Vuoi condividere numero Whatsapp?')}
                label={t('Disabled')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Form.Item name='company_click_collect_attributes.date_begin'>
              <DatePicker
                label={t('Data inizio contratto')}
                disabled={!retailOrRoot}
                size='large'
                format={'DD MMMM YYYY'}
                placeholder={t('Data inizio contratto')}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='company_click_collect_attributes.date_end'>
              <DatePicker
                disabled={!retailOrRoot}
                label={t('Data termine contratto')}
                size='large'
                format={'DD MMMM YYYY'}
                placeholder={t('Data inizio contratto')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={8}>
            <Form.Item name='company_click_collect_attributes.macro_category'>
              <Select
                disabled={!retailOrRoot}
                label={t('Macro Categoria Smart Shopping')}
                size='large'
                placeholder={t('Selezioni opzione')}
                optionFilterProp='children'
              >
                <AntSelect.Option value=''>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {filtersData.macro_categoris.map((comp) => (
                  <AntSelect.Option key={comp.value} value={comp.value}>
                    {comp.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name={'company_click_collect_attributes.product_sheet_model'}
            >
              <Select
                disabled={!retailOrRoot}
                label={t('Modello scheda prodotto')}
                size='large'
                placeholder={t('Selezioni opzione')}
                optionFilterProp='children'
                name='company'
              >
                <AntSelect.Option value=''>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {filtersData.product_sheet_models.map((comp) => (
                  <AntSelect.Option key={comp.value} value={comp.value}>
                    {comp.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'company_click_collect_attributes.products_limit'}>
              <Select
                disabled={!retailOrRoot}
                label={t('Limite articoli pubblicabili')}
                size='large'
                placeholder={t('Selezioni opzione')}
                optionFilterProp='children'
                name='company'
              >
                <AntSelect.Option value=''>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                {filtersData.products_limits.map((comp) => (
                  <AntSelect.Option key={comp.value} value={comp.value}>
                    {comp.title}
                  </AntSelect.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Divider style={{ margin: 0 }} />
      </Col>
    </Row>
  );
};

const StaffContacts = ({ onAdd, data, onChangeStaff }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={[0, 24]}>
      {data?.map((i, index) => (
        <Fragment key={index}>
          <Col span={24}>
            <Row gutter={[20, 24]}>
              <Col span={12}>
                <Select
                  label={t('Personale')}
                  size='large'
                  placeholder={t('Personale')}
                  optionFilterProp='children'
                  onChange={(e) => onChangeStaff(e, index)}
                  name='type'
                >
                  <AntSelect.Option value='1'>Not Identified</AntSelect.Option>
                </Select>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[20, 24]}>
              <Col span={12}>
                <Input
                  value={i.name}
                  name='name'
                  label={t('Nome')}
                  size='large'
                  onChange={(e) => onChangeStaff(e, index)}
                  placeholder={t('Immettere Nome')}
                />
              </Col>
              <Col span={12}>
                <Input
                  value={i.surname}
                  name={'surname'}
                  label={t('Cognome')}
                  size='large'
                  onChange={(e) => onChangeStaff(e, index)}
                  placeholder={t('Immettere Cognome')}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[20, 24]}>
              <Col span={12}>
                <Input
                  name='phone'
                  label={t('Telefono')}
                  size='large'
                  value={i.value}
                  onChange={(e) => onChangeStaff(e, index)}
                  placeholder={'+39 000 000 0000'}
                />
              </Col>
              <Col span={12}>
                <Input
                  name='email'
                  label={t('E-mail')}
                  size='large'
                  onChange={(e) => onChangeStaff(e, index)}
                  value={i.email}
                  placeholder={'example@mail.com'}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Divider style={{ margin: 0 }} />
          </Col>
        </Fragment>
      ))}

      <Col span={24}>
        <Row>
          <Col span={6} offset={18}>
            <StyledButton
              type='primary'
              block={true}
              onClick={onAdd}
              icon={<PlusOutlined style={{ marginRight: 2 }} />}
            >
              {t('Add Competitor')}
            </StyledButton>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const SmartShopping = ({ retailOrRoot }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Row gutter={[12, 12]}>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.is_click_reserve'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Click & Reserve')}
                label={t('Enabled')}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.is_click_collect'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Click & Collect (Details are required)')}
                label={t('Enabled')}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='company_click_collect_attributes.is_online_shop'
              valuePropName='checked'
            >
              <Checkbox
                disabled={!retailOrRoot}
                mainLabel={t('Shop online (Details are required)')}
                label={t('Enabled')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Divider style={{ margin: 0 }} />
      </Col>
    </Row>
  );
};

const Appearance = ({
  retailOrRoot,
  item,
  updateInProcess,
  handleDeleteFile,
}) => {
  const draggerProps = {};
  const { t } = useTranslation();
  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <div>
          <Form.Item label={t('Immagine header del brand')}>
            <Form.Item
              name='header_image_click_collect'
              valuePropName='fileList'
              getValueFromEvent={FormHelper.normFile}
              noStyle
              multiple={false}
            >
              <Dragger
                disabled={!retailOrRoot}
                name='file'
                multiple={false}
                beforeUpload={FormHelper.beforeUpload}
              >
                <p className='ant-upload-drag-icon'>
                  <CloudGold />
                </p>
                <p className='ant-upload-text'>
                  Drag & drop files, or browse in your files
                </p>
                <p className='ant-upload-hint'>
                  {t('File Supported JPG, PNG, GIF')} <br />
                  {t('Maximum size 20 MB')}
                </p>
              </Dragger>
            </Form.Item>
          </Form.Item>
          <Row>
            <Col span={24}>
              <FileList
                onDelete={handleDeleteFile}
                loading={updateInProcess}
                data={
                  item?.company_click_collect?.header_image_click_collect?.url
                    ? [
                        {
                          file: {
                            url: item?.company_click_collect
                              ?.header_image_click_collect?.url,
                            file_name:
                              item?.company_click_collect
                                ?.header_image_click_collect?.filename,
                            id: item?.company_click_collect
                              ?.header_image_click_collect?.id,
                          },
                          image_id:
                            item?.company_click_collect
                              ?.header_image_click_collect?.id,
                          param: 'header_image_click_collect',
                        },
                      ]
                    : []
                }
              />
            </Col>
          </Row>
        </div>
      </Col>
      <Col span={24}>
        <div>
          <Form.Item label={t('Logo')}>
            <Form.Item
              name='logo_click_collect'
              valuePropName='fileList'
              getValueFromEvent={FormHelper.normFile}
              noStyle
              multiple={false}
            >
              <Dragger
                name='file'
                multiple={false}
                beforeUpload={FormHelper.beforeUpload}
                disabled={!retailOrRoot}
              >
                <p className='ant-upload-drag-icon'>
                  <CloudGold />
                </p>
                <p className='ant-upload-text'>
                  Drag & drop files, or browse in your files
                </p>
                <p className='ant-upload-hint'>
                  {t('File Supported JPG, PNG, GIF')} <br />
                  {t('Maximum size 20 MB')}
                </p>
              </Dragger>
            </Form.Item>
          </Form.Item>
          <Row>
            <Col span={24}>
              <FileList
                onDelete={handleDeleteFile}
                loading={updateInProcess}
                data={
                  item?.company_click_collect?.logo_click_collect?.url
                    ? [
                        {
                          file: {
                            url: item?.company_click_collect?.logo_click_collect
                              ?.url,
                            file_name:
                              item?.company_click_collect?.logo_click_collect
                                ?.filename,
                            id: item?.company_click_collect?.logo_click_collect
                              ?.id,
                          },
                          image_id:
                            item?.company_click_collect?.logo_click_collect?.id,
                          param: 'logo_click_collect',
                        },
                      ]
                    : []
                }
              />
            </Col>
          </Row>
        </div>
      </Col>
      <Col span={24}>
        <div>
          <Form.Item label={t('Insegna Brand Smart Shopping')}>
            <Form.Item
              name='company_image_click_collect'
              valuePropName='fileList'
              getValueFromEvent={FormHelper.normFile}
              noStyle
              multiple={false}
            >
              <Dragger
                disabled={!retailOrRoot}
                name='file'
                multiple={false}
                beforeUpload={FormHelper.beforeUpload}
              >
                <p className='ant-upload-drag-icon'>
                  <CloudGold />
                </p>
                <p className='ant-upload-text'>
                  Drag & drop files, or browse in your files
                </p>
                <p className='ant-upload-hint'>
                  {t('File Supported JPG, PNG, GIF')} <br />
                  {t('Maximum size 20 MB')}
                </p>
              </Dragger>
            </Form.Item>
          </Form.Item>
          <Row>
            <Col span={24}>
              <FileList
                onDelete={handleDeleteFile}
                loading={updateInProcess}
                data={
                  item?.company_click_collect?.company_image_click_collect?.url
                    ? [
                        {
                          file: {
                            url: item?.company_click_collect
                              ?.company_image_click_collect?.url,
                            file_name:
                              item?.company_click_collect
                                ?.company_image_click_collect?.filename,
                            id: item?.company_click_collect
                              ?.company_image_click_collect?.id,
                          },
                          image_id:
                            item?.company_click_collect
                              ?.company_image_click_collect?.id,
                          param: 'company_image_click_collect',
                        },
                      ]
                    : []
                }
              />
            </Col>
          </Row>
        </div>
      </Col>
      <Col span={24}>
        <Divider style={{ margin: 0 }} />
      </Col>
      <Col span={24}>
        <Row gutter={[20, 24]}>
          {/*<Col span={12}>*/}
          {/*  <Input*/}
          {/*    // eslint-disable-next-line*/}
          {/*    label={t("Testo descrittivo sotto l'immagine header")}*/}
          {/*    size='large'*/}
          {/*    placeholder={t('Immettere Denominazione')}*/}
          {/*  />*/}
          {/*</Col>*/}
          <Col span={12}>
            <Form.Item name={'company_click_collect_attributes.email_support'}>
              <Input
                disabled={!retailOrRoot}
                prefix={<EnvelopeIcon />}
                label={t('Email support')}
                size='large'
                placeholder={'example@mail.com'}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const VillageConventions = ({}) => {
  const { t } = useTranslation();
  return (
    <Row gutter={[12, 12]}>
      <Col span={8}>
        <Form.Item
          valuePropName='checked'
          name='company_data_attributes.village_contract'
        >
          <Checkbox
            mainLabel={t('Sconto dipendenti village')}
            label={t('Enabled')}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          valuePropName='checked'
          name='company_data_attributes.one_day_card'
        >
          <Checkbox mainLabel={t('One day card')} label={t('Disabled')} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          valuePropName='checked'
          name='company_data_attributes.gift_cards'
        >
          <Checkbox mainLabel={t('Gift Card')} label={t('Disabled')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

const Fatturati = ({ form, isNew }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[12, 0]}>
      <Col span={24}>
        <Form.Item name='invoice_year_type'>
          <Radio.Group>
            <Radio value='half_year'>{t('Fatturato semestrale')}</Radio>
            <Radio value='year'>{t('Fatturato annuale')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item name='exclude_reminder_notification' valuePropName='checked'>
          <Checkbox
            mainLabel={t('Escludi notifica reminder')}
            disabled={isNew}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

const CompanyForm = ({
  form,
  prestigeLevels,
  allCompanies,
  companyCategories,
  companyChildCategories,
  isNew,
  item,
  chains,
  filtersData,
  updateInProcess,
  handleDeleteFile,
  deliveryType,
  returnType,
  retailOrRoot,
  isRoot,
  siteCategories = [],
}) => {
  const { t } = useTranslation();
  const isEdit = !isNew;

  const [state, setState] = useState({
    company_employee_contacts_attributes: [
      {
        contact_type: 1,
        name: '',
        surname: '',
        phone: '',
        email: '',
      },
    ],
    company_table_prices_attributes: [
      {
        price_type: 1,
        to_30: '',
        from_30_to_50: '',
        from_50_to_100: '',
        from_100_to_150: '',
        from_150_to_200: '',
        from_200_to_250: '',
        from_250: '',
      },
    ],
  });

  useEffect(() => {
    if (item) {
      const prepared = {};
    }
  }, [item]);

  const onAddStaff = () => {
    setState((s) => ({
      ...s,
      company_employee_contacts_attributes: [
        ...s.company_employee_contacts_attributes,
        {
          contact_type: 1,
          name: '',
          surname: '',
          phone: '',
          email: '',
        },
      ],
    }));
  };

  const onChangeStaff = (e, index) => {
    const {
      target: { name, value },
    } = e;
    setState((s) => {
      const { company_employee_contacts_attributes } = s;
      const updated = [];
      company_employee_contacts_attributes.forEach((e, i) => {
        if (i === index) {
          updated.push({
            ...e,
            [name]: value,
          });
          return;
        }
        updated.push(e);
      });
      return {
        ...s,
        company_employee_contacts_attributes: updated,
      };
    });
  };

  return (
    <Row style={{ marginTop: 50 }} gutter={[24, 24]}>
      <Col span={24}>
        <Row>
          <Col span={5}>
            <Title>Info Generali</Title>
          </Col>
          <Col span={19}>
            <GeneralInfo
              siteCategories={siteCategories}
              isEdit={isEdit}
              retailOrRoot={retailOrRoot}
              isNew={isNew}
              chains={chains}
              item={item}
              data={state}
              prestigeLevels={prestigeLevels}
              companyCategories={companyCategories}
              companyChildCategories={companyChildCategories}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 55 }}>
          <Col span={5}>
            <Title>{t('Fatturati')}</Title>
          </Col>
          <Col span={19}>
            <Fatturati form={form} isNew={isNew} />
          </Col>
        </Row>
        {!isNew && isRoot && (
          <Row style={{ marginTop: 55 }}>
            <Col span={5}>
              <Title>Competitors</Title>
            </Col>
            <Col span={19}>
              <Competitors competitors={filtersData.contractors} />
            </Col>
          </Row>
        )}
        <Row style={{ marginTop: 55 }}>
          <Col span={5}>
            <Title>{t('Contatti Store')}</Title>
          </Col>
          <Col span={19}>
            <GeneralContacts isNew={isNew} />
          </Col>
        </Row>
        <Row style={{ marginTop: 55 }}>
          <Col span={5}>
            <Title>{t('Ragione Sociale Store')}</Title>
          </Col>
          <Col span={19}>
            <Address />
          </Col>
        </Row>
        {!isNew && (
          <Row style={{ marginTop: 55 }}>
            <Col span={5}>
              <Title>{t('Contatti Aziendali')}</Title>
            </Col>
            <Col span={19}>
              <AdministratorContacts isNew={isNew} />
            </Col>
          </Row>
        )}
        <Row style={{ marginTop: 55 }}>
          <Col span={5}>
            <Title>{t('Personale')}</Title>
          </Col>
          <Col span={19}>
            <Personal />
          </Col>
        </Row>
        <Row style={{ marginTop: 55 }}>
          <Col span={5}>
            <Title>{t('Convenzioni Village')}</Title>
          </Col>
          <Col span={19}>
            <VillageConventions />
          </Col>
        </Row>
        <Row style={{ marginTop: 55 }}>
          <Col span={5}>
            <Title>{t('Pagamenti accettati')}</Title>
          </Col>
          <Col span={19}>
            <PaymentsAccept form={form} />
          </Col>
        </Row>
        {!isNew && (
          <Row style={{ marginTop: 55 }}>
            <Col span={5}>
              <Title>{t('Smart shopping')}</Title>
            </Col>
            <Col span={19}>
              <SmartShopping retailOrRoot={retailOrRoot} />
            </Col>
          </Row>
        )}
        {!isNew && (
          <Row style={{ marginTop: 24 }}>
            <Col span={5}>
              <Title>{t('Bank')}</Title>
            </Col>
            <Col span={19}>
              <Bank
                retailOrRoot={retailOrRoot}
                filtersData={filtersData}
                companies={allCompanies}
              />
            </Col>
          </Row>
        )}
        {!isNew && (
          <Row style={{ marginTop: 24 }}>
            <Col span={5}>
              <Title>{t('Condizioni resi, Cambi, Garanzia')}</Title>
            </Col>
            <Col span={19}>
              <Conditions retailOrRoot={retailOrRoot} item={item} />
            </Col>
          </Row>
        )}
        {!isNew && (
          <Row style={{ marginTop: 54 }}>
            <Col span={5}>
              <Title>{t('Tariffe spedizioni acquisti')}</Title>
            </Col>
            <Col span={19}>
              <PurchaseShippingRates
                retailOrRoot={retailOrRoot}
                deliveryType={deliveryType}
              />
            </Col>
          </Row>
        )}
        {!isNew && (
          <Row style={{ marginTop: 54 }}>
            <Col span={5}>
              <Title>{t('TARIFFE SPEDIZIONE RESI')}</Title>
            </Col>
            <Col span={19}>
              <Resi retailOrRoot={retailOrRoot} returnType={returnType} />
            </Col>
          </Row>
        )}
        {!isNew && (
          <Row style={{ marginTop: 54 }}>
            <Col span={5}>
              <Title>{t('Insegna Smart Shopping')}</Title>
            </Col>
            <Col span={19}>
              <Appearance
                retailOrRoot={retailOrRoot}
                updateInProcess={updateInProcess}
                handleDeleteFile={handleDeleteFile}
                item={item}
              />
            </Col>
          </Row>
        )}
      </Col>
      <Col span={3} />
    </Row>
  );
};

export default CompanyForm;
